import React, { useEffect, useState, useMemo, useRef } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { TextField } from "@mui/material";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Autocomplete from "@mui/material/Autocomplete";

import Chip from "@mui/material/Chip";

import { DataGrid } from "@mui/x-data-grid";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/ro";
dayjs.locale("ro");

import IconButton from "@mui/material/IconButton";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";

import axios from "axios";
import _ from "lodash";
import debounce from "lodash.debounce";

import Header from "./components/header";
import ViewDialog from "./components/ViewDialog";
import EditDialog from "./components/EditDialog";
import { Link, useNavigate } from "react-router-dom";

function getDate(params) {
  return dayjs(params.row.start_time).format("DD.MM.YY");
  //   return `${params.row.p_name || ""} `;
}

const initialState = {
  service_type: "",
  doctor: null,
  status: "",
  date: null,
  filter: "",
};

let status_options = [
  { id: "created", label: "Created", color: "disabled" },
  { id: "confirmed", label: "Confirmed", color: "primary" },
  { id: "completed", label: "Completed", color: "success" },
  { id: "canceled", label: "Canceled", color: "error" },
];

let service_options = [
  { id: "Reumatologie", label: "Reumatologie" },
  { id: "Recuperare Medicala", label: "Recuperare Medicala" },
];

function Doctors() {
  const [docApi, setDocApi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = React.useState(0);

  const deleteDocApi = async (id) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `/doctors/` + id
    );
    if (response.statusText === "OK") {
      setDocApi(docApi.filter((row) => row._id !== id));
      setTotal(total - 1);
      // console.log("deleted");
    }
  };

  const getDocApi = async () => {
    const { data } = await axios.get(
      process.env.REACT_APP_API_URL + `/doctors?limit=100`
    );
    // console.log("doclist", data.docs);
    setDocApi(data.docs);
    setLoading(false);
    setTotal(data.docs.length);
  };

  useEffect(() => {
    getDocApi();
    // getAppApi();
  }, []);

  const navigate = useNavigate();
  const handleEditDoctor = (id) => {
    navigate("/doctors/" + id);
  };

  const handleDeleteClick = (e, item) => {
    e.stopPropagation();
    // console.log(item);
    if (window.confirm("Do you really want to delete this doctor?")) {
      deleteDocApi(item._id);
    }
  };

  return (
    <>
      <Header></Header>
      <Container maxWidth="xl">
        <Grid
          container
          alignItems="center"
          direction="row"
          justifyContent="space-between"
        >
          <Grid item xs={10}>
            <Typography variant="h6" sx={{ mt: 4 }}>
              Lista Doctori
            </Typography>
          </Grid>
          <Grid item xs={2} sx={{ textAlign: "right" }}>
            <Button
              variant="contained"
              color="error"
              size="large"
              component={Link}
              to="/doctors/new"
            >
              Add New Doctor
            </Button>
          </Grid>
        </Grid>

        <div style={{ height: 800, width: "100%" }}>
          <div style={{ display: "flex", height: "100%" }}>
            <div style={{ marginTop: 16, flexGrow: 1 }}>
              <DataGrid
                loading={loading}
                rows={docApi}
                pageSize={50}
                rowsPerPageOptions={[50]}
                rowCount={total}
                // paginationMode="server"
                // onPageChange={(newPage) => {
                //   setPage(newPage);
                // }}
                disableColumnFilter={true}
                disableColumnMenu={true}
                disableColumnSelector={true}
                editMode="row"
                getRowId={(row) => row._id}
                sx={{
                  "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                    outline: "none !important",
                  },
                }}
                columns={[
                  {
                    field: "name",
                    headerName: "Nume",
                    flex: 2,
                    // width: 300,
                    sortable: false,
                    renderCell: (params) => {
                      return (
                        <Typography
                          variant="h6"
                          onClick={(e) => handleEditDoctor(params.row._id)}
                        >
                          {params.value}
                        </Typography>
                      );
                    },
                  },
                  {
                    field: "specialitate",
                    headerName: "Service ",
                    flex: 1,
                    sortable: false,
                  },

                  {
                    field: "email",
                    headerName: "Email ",
                    flex: 1,
                    sortable: false,
                  },

                  {
                    field: "phone",
                    headerName: "Telefon",
                    flex: 1,
                    sortable: false,
                  },

                  {
                    field: "_id",
                    headerName: "ID",
                    flex: 1,
                    sortable: false,
                  },

                  {
                    field: "actions",
                    headerName: "Actions",
                    width: 100,
                    type: "actions",
                    renderCell: (params) => {
                      return (
                        <>
                          <IconButton
                            aria-label="edit"
                            size="small"
                            onClick={(e) => handleEditDoctor(params.row._id)}
                          >
                            <ModeEditIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            size="small"
                            color="error"
                            onClick={(e) => handleDeleteClick(e, params.row)}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </>
                      );
                    },
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
export default Doctors;
